import axios from "axios";
import { IInvoiceGetDTO } from "../../coreapi-dto/documents/invoice";
import { IInvoiceItemEditDTO, IInvoiceItemGetDTO } from "../../coreapi-dto/documents/invoiceItem";
import { envF } from "../../../env";
import { IKiz2DocumentGetDTO, IKiz2DocumentItemGetDTO } from "../../coreapi-dto/dirs/kiz";

export const getInvoiceItemUpdateDTO = async (
    idDocument: string,
    callback: (e: IInvoiceItemEditDTO[]) => void,
    editInvoice?: IInvoiceGetDTO
) => {
    const jwtToken = localStorage.getItem("TokenData") as string;
    const token = `Bearer ${JSON.parse(jwtToken).accessToken}`;
    const header = {
        headers: {
            Authorization: token,
        },
    };

    const generateKizDocumentRequestUrl = () =>
        `${envF.REACT_APP_API_GATEWAY_PATH}/Kiz/Document/${idDocument}`;

    const generateInvoiceRequestUrl = () =>
        `${envF.REACT_APP_API_GATEWAY_PATH}/Invoice/${idDocument}`;

    const invoice = editInvoice ?? (await axios.get<IInvoiceGetDTO>(generateInvoiceRequestUrl(), header)).data;

    // Запрос на получение КИЗ по всему документу
    let kizDocumentData: IKiz2DocumentGetDTO | null = null;
    const hasKizItems = invoice.items.some(x => (x.isKiz || x.isKizBox) && x.idGlobal);

    if (hasKizItems) {
        try {
            const kizResponse = await axios.get<IKiz2DocumentGetDTO>(generateKizDocumentRequestUrl(), header);
            kizDocumentData = kizResponse.data;
        } catch (error) {
            console.warn('[getInvoiceItemUpdateDTO] ошибка получения данных по маркированным позициям:', error);
        }
    }

    // Маппинг КИЗ по idDocumentItem для быстрого поиска
    const kizItemsMap = new Map<string, IKiz2DocumentItemGetDTO>();
    if (kizDocumentData?.items) {
        kizDocumentData.items.forEach((item: IKiz2DocumentItemGetDTO) => {
            if (item.idDocumentItemGlobal) {
                kizItemsMap.set(item.idDocumentItemGlobal, item);
            }
        });
    }

    // Финальный список строк
    const items: IInvoiceItemEditDTO[] = invoice.items.map((x: IInvoiceItemGetDTO) => {
        const kizData = x.idGlobal ? kizItemsMap.get(x.idGlobal) : undefined;
        return {
            idGlobal: x.idGlobal,
            idGoodsGlobal: x.goods.idGlobal,
            idScalingRatioGlobal: x.scalingRatio.idGlobal,
            idGosContractGoodsExternalGlobal: x?.idGosContractGoodsGlobal,
            idGosContractExternalGlobal: x?.idGosContractGlobal,
            idSeriesGlobal: x.series?.idGlobal,
            quantity: x.quantity,
            producerPrice: x.producerPrice,
            productMargin: x.productMargin,
            supplierCostInfo: x.supplierCostInfo,
            retailCostInfo: x.retailCostInfo,
            supplierGoodsCode: x.supplierGoodsCode,
            gtdNumber: x.gtdNumber,
            barCode: x.barCode,
            isLs: x.isLs,
            registerPrice: x.registerPrice,
            isKiz: x.isKiz,
            isKizBox: x.isKizBox,
            isGnvls: x.isGnvls,
            kizBoxCount: x.kizBoxCount,
            kizCount: x.kizCount,
            denominator: x.denominator,
            numerator: x.numerator,
            goodsCode: x.goodsCode,
            producer: x.producer,
            idInvoiceItemGroupGlobal: x.idInvoiceItemGroupGlobal,
            dateCreated: x.dateCreated,
            gtin: x.gtin,
            kizOsuDto: x.kizOsuDto,
            isOsu: x.isOsu,
            ...(kizData && {
                kizs: kizData.kizes ?? [],
                kizBoxes: kizData.kizBoxes ?? [],
                kizOsuDtos: kizData.kizOsuDtos ?? [],
                kizBoxesGisMt: kizData.kizBoxesGisMt
            }),
            actualQuantity: x.actualQuantity,
            damageQuantity: x.damageQuantity,
            defectQuantity: x.defectQuantity,
            shortageQuantity: x.shortageQuantity,
            isPieceAccountingKizOsu: x.isPieceAccountingKizOsu
        } as IInvoiceItemEditDTO;
    });

    callback(items);
};
